import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@aeCore/services/user.service';
import { EUserType } from '@aeCore/enums/user-role.enum';

@Directive({
  standalone: true,
  selector: '[appHasPermission]',
})
export class HasPermissionDirective {
  @Input() set appHasPermission(permission: string | string[]) {
    this.updateView(permission).then();
  }

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private userService: UserService
  ) {}

  private async updateView(permission: string | string[]): Promise<void> {
    const userType = this.userService.user?.type;
    this.viewContainer.clear();

    if (userType === EUserType.SUPER_ADMIN || (await this.userService.hasPermission(permission))) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
